import React from 'react';
//import logo from './s1iwy.JPG';
import {
 // Flex,
  Heading,
//  Image,
//  View,
} from "@aws-amplify/ui-react";
import { Link } from 'react-router-dom';

function Home (){
	return (<>
	


	<div className='navBarBox' >    <span className="navBarTitle">GSAlpha </span>

<Link className='navBarLink' style={{ textDecoration: 'none' }} to="/">  Home</Link>

<Link className='navBarLink' style={{ textDecoration: 'none' }} to="/about">About</Link>

</div>
<div className='pageContent' >

	<br></br>
	<Heading level={2}>GSAlpha Cloud PC Help</Heading>
	<br></br>
	
</div>	

<div style={{ textAlign: 'left', paddingLeft: '10%' }}>
<span className='pageContentMed'>GENERAL USE</span>
<p style={{ paddingLeft: '2vmin' }}>
-To start the Cloud PC, use the START button on the GSAlpha Portal<br></br>
-Connect to the Cloud PC with RDP for the first time, using the RDP Connect button and install a desktop streaming app (i.e PARSEC)<br></br>
-Buy more time via PayPal with the Add Time button<br></br>
-To shutdown the Cloud PC, use the STOP button on the GSAlpha Portal<br></br>
-The Cloud PC will backup each time it is stopped.
-It normally takes 2-4min for the Cloud PC to become available after using the START Button
-The GSAlpha Portal does not need to be left open in order to complete the start up or shut down/backup process once it has been initiated
</p>
<br></br>
<span className='pageContentMed'>FIRST TIME SETUP (Using PARSEC)</span>
<p style={{ paddingLeft: '2vmin' }}>
1) Create a free PARSEC account at www.parsec.app<br></br>
2) Start the Cloud PC and wait until startup is complete and 'Running' is displayed<br></br>
3) Connect to the Remote PC using RDP (Press the 'RDP Connect' button on the GSAlpha Portal)<br></br>
4) Install and run PARSEC on the Cloud PC<br></br>
5) Install and run PARSEC on your Home PC<br></br>
6) Use PARSEC on your Home PC to connect to the Cloud PC (you can connect once the Cloud PC is 'Running')<br></br>
</p>
<br></br>
<span className='pageContentMed'>PERIPHERALS</span><br></br>
<p style={{ paddingLeft: '2vmin' }}>
-PARSEC will allow you to use your KB/Mouse and Gamepad with the Cloud PC<br></br>
-VirtualHere is recomended to connect USB Joysticks and Wheels to the Cloud PC
</p>
<br></br>
<span className='pageContentMed'>ADDITIONAL FEATURES</span>
<p style={{ paddingLeft: '2vmin' }}>
-Reset Cloud PC Software to Initial State: While Cloud PC is STOPPED, use the OPTION Button and then the RESET Button.
-Rollback Cloud PC to last Backup: While Cloud PC is RUNNING, use the OPTION Button and then the ROLLBACK Button.
-SMS Time Alerts: To ENABLE or DISABLE SMS Alerts, while Cloud PC is STOPPED, use the OPTION Button and then the SMS ALERTS Button.
-Auto Shut Down Time: To modify the Auto Shut Down Time, while Cloud PC is RUNNING, use the OPTION Button and then the SD Time Button.
</p>

	</div>

	  </>)
		
	
	
}

export default Home;
